import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { apiFetch } from   "../../components/helpers";

export default function Reports() {
  const [stats, setStats] = useState({
    totalRevenue: 0,
    appointments: 0,
    avgPerAppointment: 0,
    growth: 0,
  });

  const [monthly, setMonthly] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    setLoading(true);

    try {
      const s = await apiFetch(
        process.env.REACT_APP_REPORTS_STATS
      );

      const m = await apiFetch(
        process.env.REACT_APP_REPORTS_MONTHLY
      );

      const t = await apiFetch(
        process.env.REACT_APP_REPORTS_TREATMENT
      );

      const d = await apiFetch(
        process.env.REACT_APP_REPORTS_DOCTORS
      );

      if (s.status) setStats(s.data);
      if (m.status) setMonthly(m.data || []);
      if (t.status) setTreatments(t.data || []);
      if (d.status) setDoctors(d.data || []);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const colors = [
    "#16a34a",
    "#3b82f6",
    "#f97316",
    "#8b5cf6",
    "#f59e0b",
    "#94a3b8",
  ];

  if (loading) {
    return (
      <div className="p-4">
        Loading...
      </div>
    );
  }

  return (
    <div className="p-4">

      <h2 className="fw-bold mb-1">
        Reports & Analytics
      </h2>

      <p className="text-muted mb-4">
        Clinic performance overview
      </p>

      {/* cards */}
      <div className="row g-3 mb-4">

        <Card
          title="TOTAL REVENUE"
          value={`₹${Number(
            stats.totalRevenue
          ).toLocaleString()}`}
        />

        <Card
          title="APPOINTMENTS"
          value={stats.appointments}
        />

        <Card
          title="AVG PER APPOINTMENT"
          value={`₹${stats.avgPerAppointment}`}
        />

        <Card
          title="GROWTH"
          value={`${stats.growth}%`}
        />

      </div>

      <div className="row g-4">

        {/* monthly chart */}
        <div className="col-lg-8">
          <div className="card shadow-sm border-0 p-3">

            <h6 className="mb-3">
              Revenue & Appointments
            </h6>

            <ResponsiveContainer
              width="100%"
              height={300}
            >
              <BarChart data={monthly}>
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Bar
                  dataKey="revenue"
                  fill="#16a34a"
                />
              </BarChart>
            </ResponsiveContainer>

          </div>
        </div>

        {/* pie chart */}
        <div className="col-lg-4">
          <div className="card shadow-sm border-0 p-3">

            <h6 className="mb-3">
              Treatment Distribution
            </h6>

            <ResponsiveContainer
              width="100%"
              height={300}
            >
              <PieChart>
                <Pie
                  data={treatments}
                  dataKey="value"
                  nameKey="name"
                  outerRadius={100}
                  label
                >
                  {treatments.map(
                    (_, i) => (
                      <Cell
                        key={i}
                        fill={
                          colors[
                            i %
                              colors.length
                          ]
                        }
                      />
                    )
                  )}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

          </div>
        </div>

      </div>

      {/* doctor table */}
      <div className="card shadow-sm border-0 p-3 mt-4">

        <h6 className="mb-3">
          Doctor Performance
        </h6>

        <div className="table-responsive">
          <table className="table align-middle">

            <thead>
              <tr>
                <th>Doctor</th>
                <th>Patients</th>
                <th>Revenue</th>
                <th>Rating</th>
                <th>Revenue Share</th>
              </tr>
            </thead>

            <tbody>
              {doctors.map((d, i) => {
                const max =
                  doctors[0]
                    ?.revenue || 1;

                const percent =
                  Math.round(
                    (d.revenue /
                      max) *
                      100
                  );

                return (
                  <tr key={i}>
                    <td>{d.name}</td>

                    <td>
                      {d.patients}
                    </td>

                    <td>
                      ₹
                      {Number(
                        d.revenue
                      ).toLocaleString()}
                    </td>

                    <td>
                      ⭐ {d.rating}
                    </td>

                    <td
                      style={{
                        width:
                          "220px",
                      }}
                    >
                      <div
                        className="progress"
                        style={{
                          height:
                            "8px",
                        }}
                      >
                        <div
                          className="progress-bar bg-success"
                          style={{
                            width: `${percent}%`,
                          }}
                        />
                      </div>
                      <small>
                        {percent}%
                      </small>
                    </td>
                  </tr>
                );
              })}
            </tbody>

          </table>
        </div>

      </div>

    </div>
  );
}

function Card({
  title,
  value,
}) {
  return (
    <div className="col-md-3">
      <div className="card shadow-sm border-0 p-3">
        <small className="text-muted">
          {title}
        </small>

        <h2 className="fw-bold mt-2">
          {value}
        </h2>
      </div>
    </div>
  );
}